import React, { useRef, useState, useEffect, useCallback } from "react";
import FileSaver from "file-saver";
import { Form } from "@unform/web";
import NotificationAlert from "react-notification-alert";
import {
  Button,
  Card,
  Row,
  Col,
  Label,
  Container,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "reactstrap";
import { MigrationModal } from "components/InternalDashboardMigration";
import { ButtonTab, SwitchContainer, SwitchLabel } from "./styles";
import Input from "../../../components/Input";
import RecoverMenu from "./RecoverMenu";
import BulkDeleteInputsModal from "./BulkDeleteInputsModal";
import EditProfile from "./EditProfile/EditProfile";
import EditLocation from "./EditLocation/EditLocation";
import EditPlan from "./Editplan/EditPlan";
import EditNFE from "./EditNFE/EditNFE";
import EditPayments from "./EditPayments/EditPayments";
import EditArea from "./EditArea/EditArea";
import BrandsSection from "./EditBrands/BrandsSection";
import Protocols from "./Protocols";
import { useRestaurants } from "context/RestaurantsContext";
import { useAuth } from "context/AuthContext";
import history from "../../../../services/history";
import { generateProductsSheet } from "services/generateProductsSheet";
import apiGd from "../../../../services/apiGd";
import { Checkbox } from "ui-kit-takeat";
import OrderControl from "./OrderControl";
import PrinterControl from "./PrinterControl";
// const EMAIL_ALLOWED_GENERATE_PRINTER_TOKEN = [
//   "gabrielafabian.takeat@gmail.com",
//   "miguel.carvalho@takeat.app",
//   "tarcisio.takeat@gmail.com",
//   "vmbuteri.takeat@gmail.com",
//   "stheferson@takeat.app",
//   "joaolucas.takeat@gmail.com",
// ];

function EditRestaurantGD(props) {
  const formRef = useRef(null);
  const notificationAlert = useRef(null);
  const { id } = props.match.params;
  const [restaurant, setRestaurant] = useState([]);
  const [brandsRefreshKey, setBrandsRefreshKey] = useState(0);
  const [planFeatureDefaults, setPlanFeatureDefaults] = useState(null);
  const token = localStorage.getItem("@QRExpress:tokenGd");
  const { getRestaurants } = useRestaurants();
  const { user } = useAuth();

  const [nfceCheck, setNfceCheck] = useState(false);
  const [clubeCheck, setClubeCheck] = useState(false);
  const [deleteClubeModal, setDeleteClubeModal] = useState(false);
  const [confirmDelete, setConfirmDelete] = useState("");

  const [isActive, setIsActive] = useState(false);
  const [asaasId, setAsaasId] = useState(null);
  const [onlyDelivery, setOnlyDelivery] = useState(false);
  const [onlyQrcode, setOnlyQrcode] = useState(false);
  const [useStock, setUseStock] = useState(false);
  const [useWpp, setUseWpp] = useState(false);

  const [isDeliveryAllowed, setIsDeliveryAllowed] = useState(false);
  const [isWithdrawalAllowed, setIsWithdrawalAllowed] = useState(false);
  const [isDeliveryAddressesAllowed, setIsDeliveryAddressesAllowed] =
    useState(false);
  const [isPixAllowed, setIsPixAllowed] = useState(false);
  const [isCreditCardAllowed, setIsCreditCardAllowed] = useState(false);


  const [buttonTab, setButtonTab] = useState(1);

  const [suspensionAlert, setSuspensionAlert] = useState(false);

  const [restHasIfood, setRestHasIfood] = useState(false);

  const [hasNickname, setHasNickname] = useState(false);
  const [nickname, setNickname] = useState("");
  const [plan, setPlan] = useState();
  const [passwordPanel, setPasswordPanel] = useState(false);
  const [smsService, setSmsService] = useState(false);
  const [clientPaySms, setClientPaySms] = useState(false);
  const [newPassword, setNewPassword] = useState("");
  const [nameIfood, setNameIfood] = useState("");
  const [merchantIfood, setMerchantIfood] = useState("");
  const [ifoodRestaurants, setIfoodRestaurants] = useState([]);
  const [asaasRestaurants, setAsaasRestaurants] = useState([]);
  const [users, setUsers] = useState([]);
  const [hasBalcony, setHasBalcony] = useState(false);
  const [responsibleUser, setResponsibleUser] = useState(null);
  const [ifoodPdv, setIfoodPdv] = useState(false);
  const [printerToken, setPrinterToken] = useState(null);
  const [isGeneratingPrinterToken, setIsGeneratingPrinterToken] =
    useState(false);
  const [isCopyingToken, setIsCopyingToken] = useState(false);

  const [name, setName] = useState("");
  const [instagram, setInstagram] = useState("");

  const [onlyQrcodeDisabled, setOnlyQrcodeDisabled] = useState(false);

  const [tableLimitType, setTableLimitType] = useState("unlimited-tables");
  const [isTableLimitDisabled, setIsTableLimitDisabled] = useState(true);
  const [tableLimitValue, setTableLimitValue] = useState(null);
  const [tableLimitTypeDefault, setTableLimitTypeDefault] = useState({});
  const [establishmentId, setEstablishmentId] = useState(null);

  const [Adress, setAdress] = useState({
    city: "",
    neighborhood: "",
    state: "",
    street: "",
    zip_code: "",
    number: "",
  });

  const [Settings, setSettings] = useState({
    crm_plan: "",
    crm_campaign_fee: 0,
    has_balcony: false,
    use_smart_pos: false,
    plan: null,
    use_tablet: false,
    use_ifood_pdv_code: false,
    wpp_report_active: false,
    use_balance: false,
    use_totem: false,
    is_markup_allowed: false,
  });

  const [deliveryInfo, setDeliveryInfo] = useState({
    is_delivery_allowed: false,
    allow_delivery_addresses: false,
    sms_service_price: "",
    is_sms_service_optional: false,
    has_sms_service: false,
    client_pay_sms: false,
    is_withdrawal_allowed: false,
  });

  const [restaurantData, setRestaurantData] = useState({
    adress: {
      city: "",
      neighborhood: "",
      state: "",
      street: "",
      zip_code: "",
      number: "",
    },
    asaas_id: "",
    avatar_id: null,
    city: "",
    cnpj: "",
    delivery_info: deliveryInfo,
    email: "",
    excel_file: "",
    fantasy_name: "",
    foody_delivery_token: null,
    geolocation_cb: false,
    has_balcony: false,
    has_clube: false,
    has_credit_card: false,
    has_ifood: false,
    has_99food: false,
    has_nfce: false,
    has_nickname: false,
    has_pix: false,
    ifood_merchant_id: "",
    ifood_name: "",
    instagram: "",
    is_active: false,
    is_location_limited: false,
    latitude: "",
    longitude: "",
    model_clube: "",
    name: "",
    nickname: null,
    nfce_token: "",
    number: "",
    only_delivery: false,
    only_qrcode: false,
    owner_wpp: "",
    paytime_seller_id: "",
    phone: "",
    regime_tributario: "",
    settings: Settings,
    state: "",
    street: "",
    suspension_alert: false,
    table_limit: 0,
    table_limit_type: "",
    token_clube: "",
    type_of_plan: "",
    use_ifood_pdv_code: false,
    use_foody_delivery: false,
    use_smart_pos: false,
    use_stock: false,
    use_tablet: false,
    use_totem: false,
    use_wpp: false,
    wpp_report_active: false,
    zip_code: "",
    printer_token: null,
  });

  function changeBalconyCheck() {
    setHasBalcony(!hasBalcony);
  }

  async function updatePassword() {
    const reqConfig = {
      headers: { Authorization: `Bearer ${token}` },
    };

    try {
      if (newPassword.length < 6) {
        notify("tr", "danger", "Senha tem que ter no mínimo 6 caracteres");
      } else {
        const data = { password: newPassword };
        await apiGd.put(`admin/restaurants/password/${id}`, data, reqConfig);
        toggleModalPassword();
        notify("tr", "success", "Senha atualizada com sucesso!");
      }
    } catch (err) {
      notify("tr", "danger", "Erro ao atualizar senha");
    }
  }

  function changeNfceCheck() {
    setNfceCheck(!nfceCheck);
  }

  function changeClubeCheck() {
    setClubeCheck(!clubeCheck);
  }

  function changePixAllowed() {
    setIsPixAllowed(!isPixAllowed);
  }

  function changeCreditCardAllowed() {
    setIsCreditCardAllowed(!isCreditCardAllowed);
  }

  function changeOnlyDelivery() {
    setOnlyDelivery(!onlyDelivery);
    if (!onlyDelivery === true) {
      setOnlyQrcode(true);
      setOnlyQrcodeDisabled(true);
    } else {
      setOnlyQrcodeDisabled(false);
    }
    setIsDeliveryAllowed(true);
  }

  function changeOnlyQrcode() {
    setOnlyQrcode(!onlyQrcode);
  }

  function changeDeliveryAllowed() {
    setIsDeliveryAllowed(!isDeliveryAllowed);
  }

  function changeWithdrawalAllowed() {
    setIsWithdrawalAllowed(!isWithdrawalAllowed);
  }

  function changeDeliveryAddressesAllowed() {
    setIsDeliveryAddressesAllowed(!isDeliveryAddressesAllowed);
  }

  function changeUseStock() {
    setUseStock(!useStock);
  }

  function changeSmsService() {
    setSmsService(!smsService);

    if (smsService) {
      setClientPaySms(false);
    }
  }

  function changeClientPaySms() {
    setClientPaySms(!clientPaySms);
  }

  function changeSuspensionAlert() {
    setSuspensionAlert(!suspensionAlert);
  }

  function changePasswordPanel() {
    setPasswordPanel(!passwordPanel);

    if (passwordPanel) {
      setSmsService(true);
    }
  }

  const [locationLimitedCheck, setLocationLimitedCheck] = useState();
  function changeLocationCheck() {
    setLocationLimitedCheck(!locationLimitedCheck);
  }

  const [modal, setModal] = useState(false);
  const [deletingRestaurant, setDeletingRestaurant] = useState(false);
  function toggleModal() {
    setModal(!modal);
  }

  const [modalPassword, setModalPassword] = useState(false);
  function toggleModalPassword() {
    setModalPassword(!modalPassword);
  }

  const [modalWppCode, setModalWppCode] = useState(false);
  function toggleModalWppCode() {
    setModalWppCode(!modalWppCode);
  }

  const [modalClearCache, setModalClearCache] = useState(false);
  function toggleModalClearCache() {
    setModalClearCache(!modalClearCache);
  }

  const getUsers = useCallback(async () => {
    try {
      const res = await apiGd.get("/restaurants/users", {
        headers: {
          Authorization: `Bearer: ${token}`,
        },
      });

      // removendo o usuário Admin/Padrao do nosso dash
      const users = res.data
        .filter((data) => data.id !== 1)
        .map((data) => {
          return {
            label: data.name,
            value: data.id,
          };
        });

      setUsers(users);
    } catch (err) {
      notify("tr", "danger", "Erro ao carregar informações.");
      console.log(err);
    }
  }, [token]);

  const [messageCodeWpp, setMessageCodeWpp] = useState(null);

  const sendCodeWpp = useCallback(async () => {
    try {
      const reqConfig = {
        headers: { Authorization: `Bearer ${token}` },
      };

      const res = await apiGd.post(
        `/admin/code-to-owner/${id}`,
        null,
        reqConfig
      );

      if (res.data.response.status === 400) {
        notify("tr", "danger", res.data.response.message.result_message);
      } else {
        setMessageCodeWpp(res.data.numeros);
        toggleModalWppCode();
      }
    } catch (err) {
      if (err.response.data.message) {
        notify("tr", "danger", err.response.data.message);
      }
      console.log(err);
    }
  }, [token]);

  const clearCache = useCallback(async () => {
    try {
      const reqConfig = {
        headers: { Authorization: `Bearer ${token}` },
      };

      await apiGd.put(`/admin/restaurants/clear-cache/${id}`, null, reqConfig);

      notify("tr", "success", "Cache do restaurante limpo.");
      setModalClearCache(false);
    } catch (err) {
      if (err.response.data.message) {
        notify("tr", "danger", err.response.data.message);
      }
      console.log(err);
    }
  }, [token]);

  const notify = (place, color, message) => {
    var options = {};
    options = {
      place: place,
      message: (
        <div>
          <div>{message}</div>
        </div>
      ),
      type: color,
      icon: "now-ui-icons ui-1_bell-53",
      autoDismiss: 7,
    };

    notificationAlert.current.notificationAlert(options);
  };

  const [inicialLocation, setInicialLocation] = useState([0, 0]);
  const [selectedPosition, setSelectedPosition] = useState([0, 0]);
  const [useSmartPos, setUseSmartPos] = useState(false);
  const [useTablet, setUseTablet] = useState(false);

  const [ownerWpp, setOwnerWpp] = useState("");

  function changeUseSmartPos() {
    setUseSmartPos(!useSmartPos);
  }

  const getInfo = useCallback(async () => {
    const reqConfig = {
      headers: { Authorization: `Bearer ${token}` },
    };

    try {
      const response = await apiGd.get(`admin/restaurants/${id}`, reqConfig);
      const { data } = response;
      setUsingNewPrinter(data?.settings?.using_new_printer || false);
      const restaurantData = {
        adress: data.adress,
        asaas_id: data.asaas_id,
        avatar_id: data.avatar ? data.avatar.id : null,
        city: data.city,
        cnpj: data.cnpj || "",
        delivery_info: {
          is_delivery_allowed: data.delivery_info.is_delivery_allowed,
          allow_delivery_addresses: data.delivery_info.allow_delivery_addresses,
          sms_service_price: data.delivery_info.sms_service_price,
          is_sms_service_optional: data.delivery_info.is_sms_service_optional,
          has_sms_service: data.delivery_info.has_sms_service,
          client_pay_sms: data.delivery_info.client_pay_sms,
          is_withdrawal_allowed: data.delivery_info.is_withdrawal_allowed,
          use_all_kanbans: data.delivery_info.use_all_kanbans,
        },
        email: data.email,
        excel_file: data.excel_file,
        fantasy_name: data.fantasy_name,
        foody_delivery_token: data.settings.foody_delivery_token,
        geolocation_cb: data.geolocation_cb,
        has_balcony: data.has_balcony,
        has_clube: data.has_clube,
        has_credit_card: data.has_credit_card,
        has_ifood: data.has_ifood,
        has_99food: data.has_99food,
        has_nfce: data.has_nfce,
        has_nickname: data.has_nickname,
        has_pix: data.has_pix,
        ifood_merchant_id: data.ifood_merchant_id,
        ifood_name: data.ifood_name,
        instagram: data.instagram,
        is_active: data.is_active,
        is_location_limited: data.is_location_limited,
        latitude: data.latitude,
        longitude: data.longitude,
        model_clube: data.model_clube,
        name: data.name,
        nickname: data.nickname,
        nfce_token: data.nfce_token || "",
        number: data.number,
        only_delivery: data.only_delivery,
        only_qrcode: data.only_qrcode,
        owner_wpp: data.owner_wpp,
        paytime_seller_id: data.paytime_seller_id,
        phone: data.phone,
        regime_tributario: data.regime_tributario,
        settings: data.settings,
        state: data.state,
        street: data.street,
        suspension_alert: data.suspension_alert,
        table_limit: data.table_limit,
        table_limit_type: data.table_limit_type,
        token_clube: data.token_clube,
        type_of_plan: data.type_of_plan,
        use_foody_delivery: data.settings.use_foody_delivery,
        use_ifood_pdv_code: data.use_ifood_pdv_code,
        use_smart_pos: data.use_smart_pos,
        use_stock: data.use_stock,
        use_tablet: data.use_tablet,
        use_totem: data.use_totem,
        use_wpp: data.use_wpp,
        wpp_report_active: data.settings.wpp_report_active,
        zip_code: data.zip_code,
        responsible_user_id: data.responsible_user_id,
        is_markup_allowed: data.settings.is_markup_allowed,
        printer_token: data.printer_token,
      };

      setRestaurantData(restaurantData);
      setRestaurant(data);

      setResponsibleUser(data.responsible_user_id || null);

      if (!!data.longitude && !!data.latitude) {
        setInicialLocation([data.latitude, data.longitude]);
        setSelectedPosition([data.latitude, data.longitude]);
      }

      setName(data.name);
      setInstagram(data.instagram);
      setLocationLimitedCheck(data.is_location_limited);
      setNfceCheck(data.has_nfce);
      setRestHasIfood(data.has_ifood);
      setOwnerWpp(data.owner_wpp);
      setHasNickname(data.nickname ? true : false);
      setNickname(data.nickname);
      // setNfceToken(data.nfce_token);
      setClubeCheck(data.has_clube);
      setIfoodRestaurants(data.ifood_restaurants);
      setIsActive(data.is_active);
      setSuspensionAlert(data.suspension_alert);
      setHasBalcony(data.settings.has_balcony);
      setUseSmartPos(data.settings.use_smart_pos);
      setUseTablet(data.settings.use_tablet);

      setIfoodPdv(data.settings.use_ifood_pdv_code);
      setPrinterToken(data.printer_token);

      if (data?.settings?.plan) {
        setPlan({
          label: data?.settings?.plan,
          value: data?.settings?.plan,
        });
      }

      if (!!data.only_delivery === true) {
        setOnlyQrcodeDisabled(true);
      }

      setOnlyDelivery(!!data.only_delivery);
      setOnlyQrcode(data.only_qrcode);
      setUseStock(!!data.use_stock);
      setUseWpp(!!data.use_wpp);
      setIsPixAllowed(!!data.has_pix);
      setIsCreditCardAllowed(!!data.has_credit_card);
      setTableLimitType(data.table_limit_type);
      setTableLimitValue(data.table_limit ? parseInt(data.table_limit) : null);

      setEstablishmentId(data.establishment_id || null);

      switch (data.table_limit_type) {
        case "only-balcony":
          setTableLimitTypeDefault({
            value: data.table_limit_type,
            label: "Somente balcão",
          });
          setIsTableLimitDisabled(true);
          break;
        case "limited-tables":
          setTableLimitTypeDefault({
            value: "limited-tables",
            label: "Limitar mesas",
          });
          setIsTableLimitDisabled(false);
          break;
        case "unlimited-tables":
          setTableLimitTypeDefault({
            value: "unlimited-tables",
            label: "Mesas ilimitadas",
          });
          setIsTableLimitDisabled(true);
          break;
        default:
          break;
      }

      const delivery_info = data.delivery_info || {};

      setIsDeliveryAllowed(!!delivery_info.is_delivery_allowed);
      setIsWithdrawalAllowed(!!delivery_info.is_withdrawal_allowed);
      setIsDeliveryAddressesAllowed(!!delivery_info.allow_delivery_addresses);

      setSmsService(!!delivery_info.has_sms_service);
      setClientPaySms(!!delivery_info.client_pay_sms);
      setPasswordPanel(!!delivery_info.is_sms_service_optional);

      // asaas
      if (!data.asaas_id) {
        try {
          const responseAsaas = await apiGd.get(
            `admin/asaas-customers`,
            reqConfig
          );

          setAsaasRestaurants(responseAsaas.data?.response_array);

          let asaasDefault = [{ label: "Selecione..", value: null }];

          setAsaasDefault(asaasDefault);
        } catch (err) {
          notify("tr", "danger", "Erro ao carregar informações Asaas.");
        }
      }
    } catch (err) {
      notify("tr", "danger", "Erro ao carregar informações.");
      console.log(err);
    }
  }, [id, token]);

  const [loadingAsaas, setLoadingAsaas] = useState(false);

  const getAsaas = useCallback(async () => {
    setLoadingAsaas(true);
    try {
      const reqConfig = {
        headers: { Authorization: `Bearer ${token}` },
      };

      const responseAsaas = await apiGd.get(
        `admin/asaas-customers?refresh=1`,
        reqConfig
      );

      setAsaasRestaurants(responseAsaas.data?.response_array);

      let asaasDefault = [{ label: "Selecione..", value: null }];
      if (restaurant.asaas_id) {
        const restaurantAsaasInResponseAsaas =
          responseAsaas.data?.response_array.find(
            (rest) => rest.value === restaurant.asaas_id
          );
        if (restaurantAsaasInResponseAsaas) {
          asaasDefault = restaurantAsaasInResponseAsaas;
        }
      }

      setAsaasDefault(asaasDefault);
      setAsaasId(asaasDefault?.value);
    } catch (err) {
      notify("tr", "danger", "Erro ao carregar informações Asaas.");
    }
    setLoadingAsaas(false);
  }, [restaurant, token]);

  const handleDownloadSheet = useCallback(async () => {
    try {
      const response = await apiGd.get(`/admin/products-fiscal/${id}`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      const { products, complements } = response.data;

      const sheet = await generateProductsSheet(products, complements);

      const uint = new Uint8Array(sheet);
      const blob = new Blob([uint], { type: "application/excel" });

      FileSaver.saveAs(blob, `Fiscal de produtos.xlsx`);

      notify("tr", "success", "Sucesso");
    } catch (err) {
      notify("tr", "danger", "Erro ao carregar informções de produtos.");
    }
  }, [token, id]);

  const submitDeleteClube = async () => {
    if (confirmDelete === "DELETAR") {
      try {
        apiGd.delete(`/restaurants/clube/delete/${id}`, {
          headers: { Authorization: `Bearer ${token}` },
        });

        notify("tr", "success", "Clube deletado com sucesso.");
        setDeleteClubeModal(false);
        setClubeCheck(false);
      } catch (err) {
        notify("tr", "danger", "Erro ao deletar clube.");
      }
    } else {
      notify("tr", "danger", "Digite DELETAR para confirmar.");
    }
  };

  const generatePrinterToken = useCallback(async () => {
    const reqConfig = {
      headers: { Authorization: `Bearer ${token}` },
    };
    setIsGeneratingPrinterToken(true);
    try {
      const response = await apiGd.post(
        `/admin/restaurants/generate-printer-token`,
        { restaurant_id: id },
        reqConfig
      );
      setPrinterToken(response.data.printer_token);
      setRestaurantData((prev) => ({
        ...prev,
        printer_token: response.data.printer_token,
      }));
      notify("tr", "success", "Token de impressão gerado com sucesso!");
    } catch (err) {
      notify(
        "tr",
        "danger",
        "Erro ao gerar token de impressão. Tente novamente"
      );
      console.log(err);
    } finally {
      setIsGeneratingPrinterToken(false);
    }
  }, [token, id]);

  const copyTokenToClipboard = useCallback(async (token) => {
    setIsCopyingToken(true);
    try {
      await navigator.clipboard.writeText(token);
      notify("tr", "success", "Token copiado para a área de transferência!");
      setTimeout(() => {
        setIsCopyingToken(false);
      }, 2000);
    } catch (err) {
      notify("tr", "danger", "Erro ao copiar token");
      setIsCopyingToken(false);
    }
  }, []);

  const handleAddIfoodId = async () => {
    const reqConfig = {
      headers: { Authorization: `Bearer ${token}` },
    };

    if (merchantIfood === "" || nameIfood === "") {
      notify("tr", "danger", "Preencha nome e merchant id do ifood");
    } else {
      try {
        const data = {
          restaurant_id: id,
          name: nameIfood,
          merchant_id: merchantIfood,
        };
        const response = await apiGd.post(
          `admin/restaurants/ifood/merchant`,
          data,
          reqConfig
        );
        setNameIfood("");
        setMerchantIfood("");
        setIfoodRestaurants((state) => [...state, response.data]);
        notify("tr", "success", "Inserido com sucesso");
      } catch (err) {
        notify(
          "tr",
          "danger",
          err?.response?.data?.error || "Erro ao inserir."
        );
      }
    }
  };

  const handleDeleteIfoodId = async (ifood_merchant_id) => {
    const reqConfig = {
      headers: { Authorization: `Bearer ${token}` },
      params: {
        restaurant_id: id,
        merchant_id: ifood_merchant_id,
      },
    };

    try {
      await apiGd.delete(`admin/restaurants/ifood/merchant`, reqConfig);
      setIfoodRestaurants((state) =>
        state.filter((rest) => rest.ifood_merchant_id !== ifood_merchant_id)
      );
      notify("tr", "success", "Deletado com sucesso");
    } catch (err) {
      notify("tr", "danger", "Erro ao remover.");
    }
  };

  async function updateProfile(data) {
    const activeLogistics = ['use_pickngo', 'use_agilizone', 'use_foody_delivery'].filter(
      (k) => restaurantData?.settings?.[k]
    );
    if (activeLogistics.length > 1) {
      notify(
        "tr",
        "danger",
        "Mais de uma integração de logística ativa. Selecione apenas uma antes de salvar."
      );
      return;
    }

    Object.keys(data).forEach((key) => {
      if (typeof data[key] === 'string' && data[key].trim() === '') {
        data[key] = undefined;
      }
    });

    const reqConfig = {
      headers: { Authorization: `Bearer ${token}` },
    };

    if (data.delivery_info.is_delivery_allowed || data.only_delivery) {
      data.delivery_info.is_withdrawal_allowed = true;
    } else {
      data.delivery_info.is_withdrawal_allowed = false;
    }

    try {
      data.geolocation_cb = locationLimitedCheck;
      data.is_location_limited = locationLimitedCheck;
      data.asaas_id = asaasId || restaurantData.asaas_id;

      if (data.has_clube) {
        data.model_clube = "cashback";
      } else {
        data.token_clube = null;
      }

      data.name = data.name?.toLowerCase();

      if (data.nickname) {
        data.nickname = data.nickname?.toLowerCase();
      }

      if (!hasNickname) {
        data.nickname = null;
      }

      let table_limit_type = tableLimitType;
      let table_limit = tableLimitValue;

      if (tableLimitType === "limited-tables-10") {
        table_limit_type = "limited-tables";
        table_limit = 10;
      } else if (tableLimitType === "limited-tables-30") {
        table_limit_type = "limited-tables";
        table_limit = 30;
      } else if (tableLimitType === "limited-tables") {
        if (!table_limit || table_limit === "") {
          notify("tr", "danger", "Limite o numero de mesas.");
          return false;
        }
      }

      data.table_limit_type = table_limit_type || tableLimitType;
      data.table_limit = table_limit
        ? parseInt(table_limit)
        : tableLimitValue
        ? parseInt(tableLimitValue)
        : null;

      if (data.has_pix === false && data.has_credit_card === false) {
        data.paytime_seller_id = null;
      }

      data.onlyQrcode = !data.onlyQrcode;

      delete data.cnpj;

      const filteredData = Object.fromEntries(
        Object.entries(data).filter(
          ([_, value]) => value !== null && value !== undefined
        )
      );

      filteredData.establishment_id = establishmentId;

      const response = await apiGd.put(
        `admin/restaurants/${id}`,
        filteredData,
        reqConfig
      );
      setRestaurant(response.data);
      setBrandsRefreshKey((k) => k + 1);

      // Refaz o fetch para refletir efeitos colaterais do save (ex: mesa ficha
      // criada junto com o smart POS) no estado da tela.
      await getInfo();

      // getRestaurants();
      notify("tr", "success", "Atualizado com sucesso!");
    } catch (err) {
      if (err?.response?.status === 409) {
        notify(
          "tr",
          "danger",
          err?.response?.data?.message ||
            "Não é possível ativar esta logística enquanto outra estiver ativa."
        );
        setRestaurantData((prev) => ({
          ...prev,
          settings: {
            ...prev.settings,
            use_pickngo: restaurant?.settings?.use_pickngo ?? prev.settings.use_pickngo,
            use_agilizone: restaurant?.settings?.use_agilizone ?? prev.settings.use_agilizone,
            use_foody_delivery:
              restaurant?.settings?.use_foody_delivery ?? prev.settings.use_foody_delivery,
          },
        }));
        return;
      }
      notify(
        "tr",
        "danger",
        err?.response?.data?.message || "Erro ao atualizar."
      );
      console.log(err.message);
    }
  }

  async function deleteRestaurant() {
    if (deletingRestaurant) {
      return;
    }

    const reqConfig = {
      headers: { Authorization: `Bearer ${token}` },
    };

    setDeletingRestaurant(true);

    try {
      await apiGd.delete(`admin/restaurants/${id}`, reqConfig);

      toggleModal();
      getRestaurants();
      history.goBack();
    } catch (e) {
      notify("tr", "danger", "Erro ao apagar restaurantes.");
    } finally {
      setDeletingRestaurant(false);
    }
  }

  const changeIsActive = useCallback(async () => {
    const reqConfig = {
      headers: { Authorization: `Bearer ${token}` },
    };

    try {
      const data = {
        is_active: !restaurantData.is_active,
      };

      const response = await apiGd.put(
        `admin/restaurants/status/${id}`,
        data,
        reqConfig
      );

      setRestaurantData({
        ...restaurantData,
        is_active: !restaurantData.is_active,
      });
    } catch (e) {
      notify("tr", "danger", "Erro ao ativar/desativar restaurantes.");
    }
  }, [restaurantData]);

  const changeWppReport = useCallback(async () => {
    const reqConfig = {
      headers: { Authorization: `Bearer ${token}` },
    };

    try {
      const data = {
        settings: {
          ...restaurantData.settings,
          wpp_report_active: !restaurantData.settings.wpp_report_active,
        },
      };

      await apiGd.put(`admin/restaurants/${id}`, data, reqConfig);

      setRestaurantData({
        ...restaurantData,
        settings: {
          ...restaurantData.settings,
          wpp_report_active: !restaurantData.settings.wpp_report_active,
        },
      });

      notify("tr", "success", "Atualizado com sucesso.");
    } catch (e) {
      notify(
        "tr",
        "danger",
        "Erro ao ativar/desativar relatório via whatsapp."
      );
    }
  }, [restaurantData]);

  const changeUseRouting = useCallback(async () => {
    const reqConfig = {
      headers: { Authorization: `Bearer ${token}` },
    };

    try {
      const data = {
        settings: {
          ...restaurantData.settings,
          use_routing: !restaurantData.settings.use_routing,
        },
      };

      await apiGd.put(`admin/restaurants/${id}`, data, reqConfig);

      setRestaurantData({
        ...restaurantData,
        settings: {
          ...restaurantData.settings,
          use_routing: !restaurantData.settings.use_routing,
        },
      });

      notify("tr", "success", "Atualizado com sucesso.");
    } catch (e) {
      notify("tr", "danger", "Erro ao ativar/desativar roteirização.");
    }
  }, [restaurantData]);

  let initialData = {
    fantasy_name: restaurant.fantasy_name,
    name: restaurant.name,
    nickname: restaurant.nickname,
    email: restaurant.email,
    phone: restaurant.phone,
    avatar_id: restaurant.avatar,
    longitude: restaurant.longitude,
    latitude: restaurant.latitude,
    is_location_limited: restaurant.is_location_limited,
    nfce_token: restaurant.nfce_token,
    cnpj: restaurant.cnpj,
    token_clube: restaurant.token_clube,
    paytime_seller_id: restaurant.paytime_seller_id,
    delivery_info: restaurant.delivery_info || {},
    ifood_merchant_uuid: restaurant.ifood_merchant_uuid,
    instagram: restaurant.instagram,
    city: restaurant.adress?.city,
    neighborhood: restaurant.adress?.neighborhood,
    state: restaurant.adress?.state,
    street: restaurant.adress?.street,
    zip_code: restaurant.adress?.zip_code,
    number: restaurant.adress?.number < 0 ? "" : restaurant.adress?.number,
    use_wpp: restaurant.use_wpp,
    regime_tributario: restaurant.regime_tributario,
    responsible_user_id: restaurant.responsible_user_id || null,
  };

  const [zipCodeState, setZipCodeState] = useState(restaurant.adress?.zip_code);

  const [latitudeHere, setLatitudeHere] = useState(0);
  const [longitudeHere, setLongitudeHere] = useState(0);

  // Defaults de funcionalidade por plano (fonte única no backend, derivada do
  // catálogo do asaas). Usado para preencher os toggles ao trocar de plano.
  const getPlanFeatureDefaults = useCallback(async () => {
    try {
      const res = await apiGd.get("admin/plan-feature-defaults", {
        headers: { Authorization: `Bearer ${token}` },
      });
      setPlanFeatureDefaults(res.data);
    } catch (err) {
      // Sem os defaults o cascade não roda; os toggles ficam manuais.
    }
  }, [token]);

  useEffect(() => {
    navigator.geolocation.getCurrentPosition((position) => {
      setLatitudeHere(position.coords.latitude);
      setLongitudeHere(position.coords.longitude);
    });
    getInfo();
    getUsers();
    getPlanFeatureDefaults();
  }, [getInfo, getUsers, getPlanFeatureDefaults]);

  const [asaasDefault, setAsaasDefault] = useState(null);

  const [buyerAddressSheet, setBuyerAddressSheet] = useState({ file: null, ddd: '' });
  const [inputSheet, setInputSheet] = useState(null);
  const [prodInputSheet, setProdInputSheet] = useState(null); // Ficha Técnica

  const sendInputsExcel = useCallback(
    async (data) => {
      try {
        if (inputSheet) {
          const formData = new FormData();
          formData.append("file", inputSheet, inputSheet.name);

          const reqConfig = {
            headers: { Authorization: `Bearer ${token}` },
          };

          await apiGd.post(
            `/admin/upload/inputs/${id}?version=2`,
            formData,
            reqConfig
          );

          notify("tr", "success", "Insumos criados com sucesso!");
        } else {
          notify("tr", "danger", "Selecione um arquivo antes!");
        }
      } catch (error) {
        notify(
          "tr",
          "danger",
          "Erro ao atualizar cardapio! Confira as informacoes no excel"
        );
      }
    },
    [inputSheet, id, token]
  );

  const sendBuyerAddressExcel = useCallback(
    async (data) => {
      try {
        const { file, ddd } = buyerAddressSheet;

        console.log('---', buyerAddressSheet);
        if (!ddd || ddd.length !== 2 || Number.isNaN(Number(ddd))) {
          notify("tr", "danger", "Adicione um DDD padrão válido para o telefones!");
          return;
        }

        if (file) {
          const formData = new FormData();
          formData.append("file", file, file.name);

          const reqConfig = {
            headers: { Authorization: `Bearer ${token}` },
          };

          await apiGd.post(
            `/admin/upload/buyers-addresses?restaurant_id=${id}&ddd=${ddd}`,
            formData,
            reqConfig
          );

          notify("tr", "success", "Clientes/Endereços importados com sucesso!");
        } else {
          notify("tr", "danger", "Selecione um arquivo antes!");
        }
      } catch (error) {
        notify(
          "tr",
          "danger",
          "Erro ao atualizar! Confira as informacoes no excel"
        );
      }
    },
    [id, token, buyerAddressSheet]
  );

  useEffect(() => {
    switch (tableLimitType) {
      case "unlimited-tables":
        setTableLimitValue("");
        break;
      case "limited-tables-10":
        setTableLimitValue(10);
        break;
      case "limited-tables-30":
        setTableLimitValue(30);
        break;
      case "limited-tables":
        setTableLimitValue("");
        break;
      case "only-balcony":
        setTableLimitValue("");
        break;
    }
  }, [tableLimitType]);

  const [deletedMenu, setDeletedMenu] = useState([]);
  const [protocols, setProtocols] = useState([]);
  const [loadingDeletedMenu, setLoadingDeletedMenu] = useState([]);

  async function getDeletedMenu(e) {
    setLoadingDeletedMenu(true);
    try {
      const reqConfig = {
        headers: { Authorization: `Bearer ${token}` },
      };

      const response = await apiGd.get(
        `/admin/restaurants/menu/deleted/${id}`,
        reqConfig
      );

      setDeletedMenu(response.data);
    } catch (error) {
      console.log(error);
      notify("tr", "danger", "Erro ao atualizar cardapio deletado");
    }
    setLoadingDeletedMenu(false);
  }

  async function getProtocols() {
    try {
      const reqConfig = {
        headers: { Authorization: `Bearer ${token}` },
      };

      const response = await apiGd.get(
        `/admin/restaurants/protocols/${id}`,
        reqConfig
      );

      setProtocols(response.data);
    } catch (error) {
      console.log(error);
      notify("tr", "danger", "Erro ao atualizar protocolos");
    }
  }

  function changeUseWpp() {
    setUseWpp(!useWpp);
  }

  const typeOfPlansOptions = [
    { value: "BÁSICO", label: "BÁSICO" },
    { value: "INTERMEDIÁRIO", label: "INTERMEDIÁRIO" },
    { value: "INOVAÇÃO", label: "INOVAÇÃO" },
    { value: "PRO", label: "PRO" },
    { value: "APENAS CARDÁPIO", label: "APENAS CARDÁPIO" },
  ];

  // Funcionalidades do catálogo (asaas) seguem o plano, pela fonte única do
  // backend. Não mexe em is_multistore (estrutural, fica manual) nem em toggles
  // operacionais. Só altera o estado local — persiste no salvar da tela.
  function applyCatalogFeatures(planLabel) {
    if (!planFeatureDefaults) return;
    const normalized = String(planLabel || "")
      .normalize("NFD")
      .replace(/[̀-ͯ]/g, "")
      .trim()
      .toLowerCase();
    const tier = planFeatureDefaults.plan_aliases[normalized] || null;
    const included = new Set(
      tier ? planFeatureDefaults.included_by_tier[tier] || [] : []
    );
    setRestaurantData((old) => ({
      ...old,
      has_nfce: included.has("has_nfce"),
      has_clube: included.has("has_clube"),
      use_wpp: included.has("use_wpp"),
      settings: {
        ...old.settings,
        is_markup_allowed: included.has("is_markup_allowed"),
        use_smart_pos: included.has("use_smart_pos"),
        use_bank_reconciliation: included.has("use_bank_reconciliation"),
        crm_plan: included.has("crm") ? "infinit" : "",
      },
    }));
  }

  function handleChangeTypeOfPlans(e) {
    setPlan({
      label: e,
      value: e,
    });

    // Toggles operacionais (fora do catálogo asaas) seguem a predefinição do plano.
    if (e === "APENAS CARDÁPIO") {
      setRestaurantData((old) => ({
        ...old,
        only_qrcode: true,
        only_delivery: false,
        has_pix: false,
        has_credit_card: false,
        has_balcony: false,
        delivery_info: {
          ...old.delivery_info,
          allow_delivery_addresses: false,
          is_delivery_allowed: false,
        },
      }));
    }

    if (e === "BÁSICO") {
      setRestaurantData((old) => ({
        ...old,
        only_qrcode: true,
        only_delivery: false,
        has_pix: false,
        has_credit_card: false,
        has_balcony: false,
        delivery_info: {
          ...old.delivery_info,
          allow_delivery_addresses: false,
          is_delivery_allowed: true,
        },
      }));
    }

    if (e === "INTERMEDIÁRIO") {
      setRestaurantData((old) => ({
        ...old,
        only_qrcode: true,
        only_delivery: false,
        has_pix: false,
        has_credit_card: false,
        has_balcony: true,
        delivery_info: {
          ...old.delivery_info,
          is_delivery_allowed: true,
        },
      }));
    }

    if (e === "INOVAÇÃO") {
      setRestaurantData((old) => ({
        ...old,
        only_qrcode: false,
        only_delivery: false,
        has_pix: false,
        has_credit_card: false,
        has_balcony: true,
        delivery_info: {
          ...old.delivery_info,
          is_delivery_allowed: true,
        },
      }));
    }

    if (e === "PRO") {
      setRestaurantData((old) => ({
        ...old,
        only_qrcode: false,
        only_delivery: false,
        has_pix: false,
        has_credit_card: false,
        has_balcony: true,
        delivery_info: {
          ...old?.delivery_info,
          allow_delivery_addresses: false,
          is_delivery_allowed: true,
        },
        settings: {
          ...old.settings,
          wpp_report_active: true,
        },
      }));
    }

    if (e === "ENTERPRISE") {
      setRestaurantData((old) => ({
        ...old,
        only_qrcode: false,
        only_delivery: false,
        has_pix: false,
        has_credit_card: false,
        has_balcony: true,
        delivery_info: {
          ...old.delivery_info,
          is_delivery_allowed: true,
        },
        settings: {
          ...old.settings,
          wpp_report_active: true,
        },
      }));
    }

    applyCatalogFeatures(e);
  }

  const [usingNewPrinter, setUsingNewPrinter] = useState(false);
  const [loadingUsingNewPrinter, setLoadingUsingNewPrinter] = useState(false);
  const handleToggleNewPrinter = async (e) => {
    setLoadingUsingNewPrinter(true);
    const reqConfig = {
      headers: { Authorization: `Bearer ${token}` },
    };
    const newValue = !usingNewPrinter;
    await apiGd
      .put(
        "/admin/toggle-new-printer-use",
        {
          using_new_printer: newValue,
          restaurant_id: id,
        },
        reqConfig
      )
      .then(() => {
        setUsingNewPrinter(!usingNewPrinter);
      })
      .catch((error) => {
        console.error("Error toggling new printer:", error);
      })
      .finally(() => {
        setLoadingUsingNewPrinter(false);
      });
  };

  return (
    <>
      <MigrationModal
        screen="gd/restaurants/edit"
        restaurantId={id}
        restaurantName={restaurant?.fantasy_name}
      />
      <style>
        {`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}
      </style>
      <NotificationAlert ref={notificationAlert} />

      <div className="content">
        <Row>
          <Col md="2">
            <Button color="#7A7A7A" onClick={() => history.goBack()}>
              <span className="btn-label">
                <i className="nc-icon nc-minimal-left" />
              </span>
              Voltar
            </Button>
          </Col>
        </Row>
        <Row style={{ marginBottom: 20 }}>
          <Col md="12">
            <ButtonTab
              thisButton={1}
              activeButton={buttonTab}
              onClick={() => setButtonTab(1)}
            >
              Informações Gerais
            </ButtonTab>

            {!(restaurant.is_multistore || restaurant.is_multistore_child) && (
              <ButtonTab
                thisButton={2}
                activeButton={buttonTab}
                onClick={() => {
                  setButtonTab(2);
                  getDeletedMenu();
                }}
              >
                Recuperar Cardápio
              </ButtonTab>
            )}

            <ButtonTab
              thisButton={3}
              activeButton={buttonTab}
              onClick={() => {
                setButtonTab(3);
                getProtocols();
              }}
            >
              Protocolos
            </ButtonTab>

            <ButtonTab
              thisButton={4}
              activeButton={buttonTab}
              onClick={() => {
                setButtonTab(4);
              }}
            >
              Pedidos
            </ButtonTab>

            <ButtonTab
              thisButton={5}
              activeButton={buttonTab}
              onClick={() => {
                setButtonTab(5);
              }}
            >
              Impressora
            </ButtonTab>
          </Col>
        </Row>

        {buttonTab === 1 && (
          <>
            <Row>
              <Col>
                <Button
                  onClick={toggleModal}
                  style={{
                    float: "right",
                    backgroundColor: "#C8131B",
                    borderRadius: 8,
                  }}
                >
                  Apagar
                </Button>
                <Button
                  onClick={toggleModalPassword}
                  style={{
                    float: "right",
                    marginRight: 10,
                    backgroundColor: "#FFB32F",
                    borderRadius: 8,
                  }}
                >
                  Alterar Senha
                </Button>
                <Button
                  onClick={handleDownloadSheet}
                  style={{
                    float: "right",
                    marginRight: 10,
                    background: "#01AFFF",
                    borderRadius: 8,
                  }}
                >
                  Planilha Fiscal
                </Button>
                <Button
                  onClick={() => {
                    if (
                      window.confirm(
                        "Enviar código aleátorio para WhatsApp do dono?"
                      )
                    ) {
                      sendCodeWpp();
                    }
                  }}
                  style={{
                    float: "right",
                    marginRight: 10,
                    background: "#25d366",
                    borderRadius: 8,
                  }}
                >
                  Código no Wpp
                </Button>
                <Button
                  onClick={() => toggleModalClearCache()}
                  style={{
                    float: "right",
                    marginRight: 10,
                    background: "#9E9E9E",
                    borderRadius: 8,
                  }}
                >
                  Limpar Cache
                </Button>
                <BulkDeleteInputsModal
                  restaurantId={id}
                  token={token}
                  notify={notify}
                />
              </Col>
            </Row>
            <Row>
              <Col md="12">
                <Card>
                  <BrandsSection
                    restaurantId={id}
                    token={token}
                    notify={notify}
                    restaurantData={restaurantData}
                    setRestaurantData={setRestaurantData}
                    refreshKey={brandsRefreshKey}
                    onBrandsChanged={getInfo}
                  />
                </Card>
              </Col>
            </Row>
            <Form
              ref={formRef}
              initialData={initialData}
              onSubmit={updateProfile}
            >
              <Row>
                <Col md="12">
                  <Card>
                    <EditProfile
                      sendInputsExcel={sendInputsExcel}
                      restaurantData={restaurantData}
                      setRestaurantData={setRestaurantData}
                      setInputSheet={setInputSheet}
                      token={token}
                      id={id}
                      name={name}
                      users={users}
                      hasNickname={hasNickname}
                      setHasNickname={setHasNickname}
                      buyerAddressSheet={buyerAddressSheet}
                      setBuyerAddressSheet={setBuyerAddressSheet}
                      sendBuyerAddressExcel={sendBuyerAddressExcel}
                    />
                  </Card>

                  <EditArea
                    user={user}
                    changeIsActive={changeIsActive}
                    changeWppReport={changeWppReport}
                    changeUseRouting={changeUseRouting}
                    isActive={isActive}
                    restaurantData={restaurantData}
                    setRestaurantData={setRestaurantData}
                    getAsaas={getAsaas}
                    asaasRestaurants={asaasRestaurants}
                    asaasDefault={asaasDefault}
                    setAsaasId={setAsaasId}
                    notify={notify}
                    id={id}
                  />

                  <Card>
                    <EditLocation
                      restaurantData={restaurantData}
                      setRestaurantData={setRestaurantData}
                      inicialLocation={inicialLocation}
                      setInicialLocation={setInicialLocation}
                      selectedPosition={selectedPosition}
                      setSelectedPosition={setSelectedPosition}
                      locationLimitedCheck={locationLimitedCheck}
                      changeLocationCheck={changeLocationCheck}
                      latitudeHere={latitudeHere}
                      longitudeHere={longitudeHere}
                    />
                  </Card>

                  <Card>
                    <EditPlan
                      restaurantData={restaurantData}
                      setRestaurantData={setRestaurantData}
                      handleChangeTypeOfPlans={handleChangeTypeOfPlans}
                    />
                  </Card>

                  <Card>
                    <EditNFE
                      restaurantData={restaurantData}
                      setRestaurantData={setRestaurantData}
                      setDeleteClubeModal={setDeleteClubeModal}
                      deleteClubeModal={deleteClubeModal}
                    />
                  </Card>

                  <Card>
                    <EditPayments
                      restaurantData={restaurantData}
                      setRestaurantData={setRestaurantData}
                      ifoodRestaurants={ifoodRestaurants}
                      setIfoodRestaurants={setIfoodRestaurants}
                      updateProfile={updateProfile}
                      id={id}
                      token={token}
                      notify={notify}
                      tableLimitTypeDefault={tableLimitTypeDefault}
                      setTableLimitType={setTableLimitType}
                      setIsTableLimitDisabled={setIsTableLimitDisabled}
                      setTableLimitTypeDefault={setTableLimitTypeDefault}
                      tableLimitValue={tableLimitValue}
                      isTableLimitDisabled={isTableLimitDisabled}
                      setTableLimitValue={setTableLimitValue}
                      establishmentId={establishmentId}
                      setEstablishmentId={setEstablishmentId}
                    />
                  </Card>

                  <Card>
                    <div style={{ padding: "24px" }}>
                      <h4
                        style={{
                          marginTop: "0px",
                          marginBottom: "16px",
                          color: "#333",
                          fontWeight: "600",
                          borderBottom: "2px solid #e9ecef",
                          paddingBottom: "8px",
                        }}
                      >
                        Novo app de impressão
                      </h4>
                      <Row>
                        <Col md="12">
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "space-between",
                              gap: "12px",
                              width: "fit-content",
                            }}
                          >
                            {!printerToken ? (
                              <>
                                <span
                                  style={{
                                    fontSize: "16px",
                                    fontWeight: "400",
                                    fontFamily: "Poppins",
                                    color: "#6C6C6C",
                                  }}
                                >
                                  Habilitar token de impressão no novo app
                                </span>
                                <Button
                                  color="primary"
                                  onClick={generatePrinterToken}
                                  disabled={isGeneratingPrinterToken}
                                  style={{
                                    backgroundColor: isGeneratingPrinterToken
                                      ? "#6c757d"
                                      : "#007bff",
                                    borderColor: isGeneratingPrinterToken
                                      ? "#6c757d"
                                      : "#007bff",
                                    borderRadius: "4px",
                                    fontSize: "14px",
                                    padding: "8px 16px",
                                    margin: 0,
                                    fontWeight: "500",
                                    fontFamily: "Poppins",
                                  }}
                                >
                                  Gerar Token
                                </Button>
                              </>
                            ) : (
                              <>
                                <span
                                  style={{
                                    fontSize: "16px",
                                    fontWeight: "400",
                                    fontFamily: "Poppins",
                                    color: "#6C6C6C",
                                  }}
                                >
                                  Token de Impressão:
                                </span>
                                <div
                                  onClick={
                                    isCopyingToken
                                      ? undefined
                                      : () => copyTokenToClipboard(printerToken)
                                  }
                                  style={{
                                    backgroundColor: "#F3F3F3",
                                    border: "1px solid #D1D1D1",
                                    borderRadius: "6px",
                                    padding: "10px 12px",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "space-between",
                                    cursor: isCopyingToken
                                      ? "default"
                                      : "pointer",
                                    fontFamily: "Poppins",
                                    fontSize: "14px",
                                    fontWeight: "500",
                                    color: "#6C6C6C",
                                    wordBreak: "break-all",
                                    gap: "8px",
                                    transition: "all 0.2s ease",
                                    opacity: isCopyingToken ? 0.7 : 1,
                                  }}
                                >
                                  <span
                                    style={{
                                      flex: 1,
                                    }}
                                  >
                                    {printerToken}
                                  </span>
                                  {isCopyingToken ? (
                                    <i
                                      className="nc-icon nc-check-2"
                                      style={{
                                        fontSize: "16px",
                                        color: "#28a745",
                                        flexShrink: 0,
                                      }}
                                    ></i>
                                  ) : (
                                    <i
                                      className="nc-icon nc-single-copy-04"
                                      style={{
                                        fontSize: "16px",
                                        color: "#9E9E9E",
                                        flexShrink: 0,
                                      }}
                                    ></i>
                                  )}
                                </div>
                              </>
                            )}
                            <SwitchContainer>
                              <Button
                                color="primary"
                                onClick={handleToggleNewPrinter}
                                disabled={loadingUsingNewPrinter}
                                style={{
                                  backgroundColor: loadingUsingNewPrinter
                                    ? "#6c757d"
                                    : "#007bff",
                                  borderColor: loadingUsingNewPrinter
                                    ? "#6c757d"
                                    : "#007bff",
                                  borderRadius: "4px",
                                  fontSize: "14px",
                                  padding: "8px 16px",
                                  margin: 0,
                                  fontWeight: "500",
                                  fontFamily: "Poppins",
                                }}
                              >
                                {loadingUsingNewPrinter ? (
                                  <i
                                    className="nc-icon nc-refresh-69"
                                    style={{
                                      animation: "spin 2s linear infinite",
                                    }}
                                  ></i>
                                ) : (
                                  "Toggle nova impressora"
                                )}
                              </Button>
                              <Checkbox
                                label="Usando nova impressora"
                                disabled={true}
                                checked={usingNewPrinter}
                              />
                            </SwitchContainer>
                          </div>
                        </Col>
                      </Row>
                    </div>
                  </Card>
                </Col>
              </Row>
            </Form>

            <Modal isOpen={modal} toggle={toggleModal}>
              <ModalHeader> Apagar Restaurante </ModalHeader>
              <ModalBody>
                <Container>
                  Deseja realmente apagar o restaurante{" "}
                  <b>{initialData.fantasy_name}</b>?
                  <p>
                    {" "}
                    Ao confirmar, você estará removendo este restaurante do
                    sistema, assim como todos os{" "}
                    <i style={{ color: "yellow" }}>
                      pedidos, produtos, mesas, garçons e etc
                    </i>
                    , que estejam associados a ele.{" "}
                  </p>
                </Container>
              </ModalBody>
              <ModalFooter>
                <Button
                  color="primary"
                  onClick={deleteRestaurant}
                  disabled={deletingRestaurant}
                >
                  {deletingRestaurant ? "Apagando..." : "Confirmar"}
                </Button>{" "}
                <Button
                  color="danger"
                  onClick={toggleModal}
                  disabled={deletingRestaurant}
                >
                  Cancelar
                </Button>
              </ModalFooter>
            </Modal>

            <Modal isOpen={modalWppCode} toggle={toggleModalWppCode}>
              <ModalHeader> Código no WhatsApp </ModalHeader>
              <ModalBody style={{ textAlign: "center" }}>
                <h1>{messageCodeWpp}</h1>
              </ModalBody>
            </Modal>

            <Modal isOpen={modalClearCache} toggle={toggleModalClearCache}>
              <ModalBody>
                <h2 style={{ color: "#C62828" }}>
                  <b>⚠ Atenção: Cache do Sistema (Redis)</b>
                </h2>
                <p>
                  <b>Este NÃO é o cache do navegador.</b>
                </p>
                <p>
                  Você está prestes a limpar o{" "}
                  <b>cache de dados do backend (Redis)</b>, usado internamente
                  pelo sistema para acelerar processos.
                </p>
                <p>
                  <b>Essa ação pode impactar funcionalidades temporariamente</b>{" "}
                  e deve ser feita apenas se um técnico ou suporte da Takeat
                  orientar você a isso.
                </p>
                <p style={{ color: "#C62828" }}>
                  <b>
                    Não prossiga se você não tiver certeza do que está fazendo.
                  </b>
                </p>
              </ModalBody>
              <ModalFooter>
                <Button
                  color="primary"
                  onClick={clearCache}
                  style={{ marginRight: 20 }}
                >
                  Confirmar
                </Button>
              </ModalFooter>
            </Modal>

            <Modal isOpen={modalPassword} toggle={toggleModalPassword}>
              <ModalHeader> Alterar senha </ModalHeader>
              <ModalBody>
                <Form>
                  <Container>
                    <Row>
                      <Col md="12">
                        <label> Nova Senha </label>
                        <Input
                          name="password"
                          type="text"
                          placeholder="Mínimo 6 caracteres"
                          onChange={(e) => setNewPassword(e.target.value)}
                        />
                      </Col>
                    </Row>
                  </Container>
                </Form>
              </ModalBody>
              <ModalFooter>
                <Button color="primary" onClick={updatePassword}>
                  Confirmar
                </Button>{" "}
                <Button color="danger" onClick={toggleModalPassword}>
                  Cancelar
                </Button>
              </ModalFooter>
            </Modal>

            <Modal
              isOpen={deleteClubeModal}
              toggle={() => setDeleteClubeModal(!deleteClubeModal)}
            >
              <ModalHeader>Deletar clube</ModalHeader>
              <ModalBody>
                <Container>
                  Deseja realmente deletar o clube do restaurante{" "}
                  <b>{initialData.fantasy_name}</b>?
                  <p> Para confirmar digite "DELETAR" e clique no botão.</p>
                </Container>
              </ModalBody>
              <ModalFooter>
                <Form
                  onSubmit={submitDeleteClube}
                  style={{
                    display: "flex",
                    width: "100%",
                    justifyContent: "space-evenly",
                  }}
                >
                  <Input
                    name="confirm_delete"
                    value={confirmDelete}
                    onChange={(e) => setConfirmDelete(e.target.value)}
                  />
                  <Button color="danger" type="submit">
                    Deletar
                  </Button>
                </Form>
              </ModalFooter>
            </Modal>
          </>
        )}

        {buttonTab === 2 && (
          <RecoverMenu
            menu={deletedMenu}
            loading={loadingDeletedMenu}
            getDeletedMenu={getDeletedMenu}
            notify={notify}
            restaurantId={id}
          />
        )}

        {buttonTab === 3 && (
          <Protocols
            protocols={protocols}
            notify={notify}
            users={users}
            restaurant_id={id}
            setProtocols={setProtocols}
          />
        )}

        {buttonTab === 4 && <OrderControl notify={notify} restaurant_id={id} />}

        {buttonTab === 5 && <PrinterControl notify={notify} restaurant_id={id} />}
      </div>
    </>
  );
}

export default EditRestaurantGD;
